<template>
  <el-dialog
    v-if="Modal"
    title="Santral Entegrasyon"
    :visible="Modal"
    center
    width="30%">
    <a @click="$emit('Modal', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <div v-if="Santral">
      <el-alert
        type="success"
        :closable="false"
      >Santal Entegrasyonu Aktif
      </el-alert>
      <div>
        <hr>
        <h4 @click="SantalGetir" class="text-center bg-success text-white p-1"><i class="el-icon-headset"></i>
          {{data.Santral}}</h4>
        <el-input size="small" v-model="data.SantralPass" class="input-with-select">
          <el-button type="primary" size="mini" slot="append" @click="SantralGuncelle"> Şifre Güncelle
          </el-button>
        </el-input>
      </div>
    </div>
    <div v-if="!Santral">
      <el-alert
        type="error"
        :closable="false"
      >Santal Entegrasyonu Pasif
      </el-alert>
      <hr>
      <blockquote>Telefon numaranızı arayan kat maliklerine İsimleriyle hitap ederek detaylı borç bilgisi verebilir,
        online işlem
        şifresi verebilir ve çağrı trafiğini izleyebilirsiniz.<br>
        Bu sayede borç bilgisi için zaman kaybınız olmaz. Kişi ekranlarında kişilerin ne zaman aradıklarını detaylı
        olarak
        görebilirsiniz.
      </blockquote>


    </div>
    <div slot="footer" class="dialog-footer">
      <div class="entegre">
        <a href="https://netgsm.com.tr/" target="_blank">
          <img src="https://cdn.mudu.pro/Design/netgsm.png">
        </a>
        <h5>Netgsm ile entegreyiz.</h5>
      </div>
      <a target="_blank" class="el-button float-right el-button--primary el-button--medium"
         href="https://api.whatsapp.com/send?phone=908508403806&text=Merhaba, Santral Entegrasyonu için görüşmek istiyorum."> <i class="el-icon-check"></i> Entegre Ol
      </a>
      <div class="clearfix"></div>
    </div>

  </el-dialog>
</template>

<script>
  export default {
    props: ['Modal'],
    data() {
      return {
        Santral: false,
        data: {
          SantralPass: null,
          Santral: null
        }
      }
    },
    methods: {
      SantralGuncelle() {
        this.$store.dispatch("Post", {...this.data, path: 'spesiyal/santral'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.$message.success(response.Mesaj);
            } else {
              this.$message.error(response.Mesaj);
            }
          });
      },
      SantalGetir() {
        this.$store.dispatch("Get", {path: 'spesiyal/santral'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.data = response.Veri
            }
          });
      }
    },
    created() {
      this.Santral = this.$store.getters.HizmetBilgi.Santral
      if (this.Santral) this.SantalGetir()
    }
  }
</script>

<style scoped>
  .entegre {
    display: inline-block;
    float: left;
    text-align: left;
  }

  .entegre h5 {
    font-size: 10px;
  }

  .btn {
    margin-top: 15px;
  }

  .entegre img {
    width: 80px;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pack/Entegrasyon/SantralEntegrasyon.vue